export default "__VITE_ASSET__BFEXt73D__"